import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, Dropdown, Icon, useLocalizeMessage } from 'libs.nucleus';
const variantByStatus = {
    'Published': 'common',
    'Draft': 'warning',
    'Archived': 'incomplete',
    'In Review': 'incomplete',
};
export const useConsentTableColumns = ({ onEdit, onEditRow, removeFileFromStorage, }) => {
    const translate = useLocalizeMessage();
    const labelByStatus = useMemo(() => ({
        'Published': translate('Published'),
        'Draft': translate('Draft'),
        'Archived': translate('Archived'),
        'In Review': translate('In Review'),
    }), [translate]);
    return useMemo(() => [
        {
            header: translate('Title'),
            accessorKey: 'title',
            cell: (context) => (_jsxs("div", { className: 'nucleus-flex nucleus-items-center nucleus-gap-2', children: [_jsx(Icon, { name: 'documentChartBar', size: 'sm', color: 'gray' }), context.getValue()] })),
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
        },
        {
            header: translate('Language'),
            accessorKey: 'language',
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            cell: (context) => (_jsx("span", { className: 'nucleus-block max-w-[200px] nucleus-truncate', children: context.getValue() })),
        },
        {
            header: translate('Sig fields'),
            accessorKey: 'sigFields',
        },
        {
            header: translate('Sites'),
            accessorKey: 'sites',
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            cell: (context) => {
                const status = context.getValue();
                return _jsx(Badge, { variant: variantByStatus[status], label: labelByStatus[status] });
            },
        },
        {
            id: 'actions',
            size: 48,
            cell: (context) => {
                const { id } = context.row.original;
                const dropdownItems = [
                    {
                        id: 'edit',
                        content: translate('Edit'),
                        onClick: () => {
                            if (onEditRow) {
                                onEditRow(id);
                            }
                            else if (onEdit) {
                                onEdit(id);
                            }
                        },
                    },
                    { id: 'view', content: translate('View source'), onClick: () => { } },
                    {
                        id: 'archive',
                        content: translate('Archive'),
                        onClick: () => {
                            removeFileFromStorage(id);
                        },
                        destructive: true,
                    },
                ];
                return (_jsx("section", { className: 'nucleus-flex nucleus-justify-end', children: _jsx(Dropdown, { variant: 'kebab', items: dropdownItems }) }));
            },
        },
    ], [translate, onEdit, onEditRow, removeFileFromStorage, labelByStatus]);
};
